module.exports = __webpack_public_path__ + "img/handshake.a8c29bcf.png";